import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { BoardManager } from "./BoardManager";

export class GUI extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const menuButton = new Button(this.scene, 90, 95 * GameVars.scaleY, "texture_atlas_6", "btn_menu_off", "btn_menu_on");
        menuButton.onDown(this.onClickMenu, this);
        menuButton.scaleY = GameVars.scaleY;
        this.add(menuButton);
    }

    private onClickMenu(): void {

        if (GameVars.paused) {
            return;
        }
        
        BoardManager.currentInstance.pause();

        AudioManager.playSound("btn_click");
    }
}
